<nav class="sticky top-0 z-50 bg-white shadow-lg">
    <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div class="flex justify-between items-center h-16">
            <a (click)="scrollToSection($event, 'hero')" class="cursor-pointer flex items-center space-x-2">
                <img src="http://antimgps.com/assets/images/app_logo.png" class="h-70px app-sidebar-logo-default">
            </a>
            <div class="hidden md:flex space-x-8">
                <a (click)="scrollToSection($event, 'features')"
                    class="cursor-pointer text-gray-600 hover:text-primary transition duration-300">Features</a>
                <a (click)="scrollToSection($event, 'devices')"
                    class="cursor-pointer text-gray-600 hover:text-primary transition duration-300">Devices</a>
                <a (click)="scrollToSection($event, 'plans')"
                    class="cursor-pointer text-gray-600 hover:text-primary transition duration-300">Plans</a>
            </div>
            <div class="flex items-center space-x-4">
                <a (click)="goToLogin()"
                    class="cursor-pointer text-primary hover:text-primary-dark font-medium transition duration-300">Log
                    In</a>
                <button (click)="toggleMobileMenu()"
                    class="md:hidden p-2 rounded-md text-gray-700 hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-primary">
                    <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                            d="M4 6h16M4 12h16m-7 6h7"></path>
                    </svg>
                </button>
            </div>
        </div>
    </div>

    <div id="mobile-menu" class="md:hidden" [class.hidden]="!isMobileMenuOpen">
        <div class="px-2 pt-2 pb-3 space-y-1 sm:px-3">
            <a (click)="scrollToSection($event, 'features')"
                class="cursor-pointer block px-3 py-2 rounded-md text-base font-medium text-gray-700 hover:bg-gray-50">Features</a>
            <a (click)="scrollToSection($event, 'devices')"
                class="cursor-pointer block px-3 py-2 rounded-md text-base font-medium text-gray-700 hover:bg-gray-50">Devices</a>
            <a (click)="scrollToSection($event, 'plans')"
                class="cursor-pointer block px-3 py-2 rounded-md text-base font-medium text-gray-700 hover:bg-gray-50">Plans</a>
            <a (click)="hideMobileMenu(); goToLogin()"
                class="cursor-pointer w-full text-left px-3 py-2 rounded-md text-base font-medium text-primary hover:bg-gray-50">Log
                In</a>
        </div>
    </div>
</nav>

<section id="hero" class="py-20 md:py-32">
    <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <h1 class="text-5xl md:text-6xl font-extrabold leading-tight text-gray-900 mb-4">
            The <span class="text-primary">Best-in-Class VTS</span> for Modern Fleets
        </h1>
        <p class="text-xl md:text-2xl text-gray-600 mb-8 max-w-3xl mx-auto">
            Gain unparalleled control and visibility with AnTim GPS's proprietary platform, wired, and plug-and-play OBD
            devices.
        </p>
        <div class="flex justify-center space-x-4">
            <a (click)="scrollToSection($event, 'plans')"
                class="cursor-pointer inline-block text-center bg-primary text-white px-8 py-4 text-lg rounded-xl font-bold hover:bg-primary-dark transition duration-300 shadow-xl transform hover:scale-105">
                View Plans
            </a>
            <a (click)="scrollToSection($event, 'features')"
                class="cursor-pointer inline-block text-center bg-white text-primary border border-primary px-8 py-4 text-lg rounded-xl font-bold hover:bg-gray-50 transition duration-300 shadow-xl transform hover:scale-105">
                Explore Features
            </a>
        </div>
        <div class="mt-16">
            <div
                class="mx-auto bg-white border border-gray-200 rounded-2xl shadow-3xl overflow-hidden max-w-6xl p-4 md:p-8">
                <div
                    class="bg-gray-100 flex items-center justify-center rounded-xl border-dashed border-2 border-gray-300 overflow-hidden">

                    <img src="assets/images/mobile-landing-page.PNG"
                        class="block md:hidden w-full h-auto object-contain" alt="Mobile Tracking Dashboard">

                    <img src="assets/images/tablet-landing-page.PNG"
                        class="hidden md:block lg:hidden w-full h-auto object-contain" alt="Tablet Tracking Dashboard">

                    <img src="assets/images/antimgps_tracking 1.png"
                        class="hidden lg:block w-full h-auto object-contain" alt="Desktop Tracking Dashboard">
                </div>
            </div>
        </div>
    </div>
</section>

<section id="features" class="py-16 md:py-24 bg-white">
    <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <h2 class="text-4xl font-bold text-center text-gray-900 mb-4">Powerful Features, Total Control</h2>
        <p class="text-xl text-center text-gray-600 mb-12">Everything you need to manage vehicles, drivers, and
            operations efficiently.</p>
        <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            <div
                class="p-6 bg-white rounded-xl shadow-lg hover:shadow-2xl transition duration-500 border border-gray-100">
                <i data-lucide="map-pin" class="text-primary w-10 h-10 mb-4"></i>
                <h3 class="text-xl font-semibold mb-2">Real-Time Live Tracking</h3>
                <p class="text-gray-600">Pinpoint vehicle location with high precision, instantly. See speed, status,
                    and history in a fluid, easy-to-use map interface.</p>
            </div>
            <div
                class="p-6 bg-white rounded-xl shadow-lg hover:shadow-2xl transition duration-500 border border-gray-100">
                <i data-lucide="bar-chart-3" class="text-primary w-10 h-10 mb-4"></i>
                <h3 class="text-xl font-semibold mb-2">Reports & Analytics</h3>
                <p class="text-gray-600">Comprehensive, customizable reports on fuel consumption, driving behavior, and
                    utilization for data-driven decisions.</p>
            </div>
            <div
                class="p-6 bg-white rounded-xl shadow-lg hover:shadow-2xl transition duration-500 border border-gray-100">
                <i data-lucide="fence" class="text-primary w-10 h-10 mb-4"></i>
                <h3 class="text-xl font-semibold mb-2">Geofence Alerts & Control</h3>
                <p class="text-gray-600">Define virtual boundaries (fences) and receive instant notifications when
                    vehicles enter or exit specified areas or routes.</p>
            </div>
            <div
                class="p-6 bg-white rounded-xl shadow-lg hover:shadow-2xl transition duration-500 border border-gray-100">
                <i data-lucide="message-circle" class="text-primary w-10 h-10 mb-4"></i>
                <h3 class="text-xl font-semibold mb-2">WhatsApp Notifications</h3>
                <p class="text-gray-600">Get critical alerts (ignition, speed, fence breaches) directly on WhatsApp for
                    immediate action and ease of use.</p>
            </div>
            <div
                class="p-6 bg-white rounded-xl shadow-lg hover:shadow-2xl transition duration-500 border border-gray-100">
                <i data-lucide="car" class="text-primary w-10 h-10 mb-4"></i>
                <h3 class="text-xl font-semibold mb-2">Trip & Vehicle Management</h3>
                <p class="text-gray-600">Manage trip assignments, maintain vehicle records, and track detailed trip
                    playback for dispute resolution.</p>
            </div>
            <div
                class="p-6 bg-white rounded-xl shadow-lg hover:shadow-2xl transition duration-500 border border-gray-100">
                <i data-lucide="bell" class="text-primary w-10 h-10 mb-4"></i>
                <h3 class="text-xl font-semibold mb-2">Reminders & Maintenance</h3>
                <p class="text-gray-600">Automated service, insurance, and document reminders to ensure compliance and
                    minimize vehicle downtime.</p>
            </div>
        </div>
    </div>
</section>

<section id="devices" class="py-16 md:py-24 bg-gray-50">
    <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <h2 class="text-4xl font-bold text-center text-gray-900 mb-4">Flexible Device Options</h2>
        <p class="text-xl text-center text-gray-600 mb-12">Choose the device that fits your fleet's needs, all connected
            to our powerful platform.</p>
        <div class="grid grid-cols-1 md:grid-cols-2 gap-12">
            <div class="bg-white p-8 rounded-2xl shadow-3xl border-t-4 border-primary">
                <i data-lucide="zap" class="text-primary w-12 h-12 mb-4"></i>
                <h3 class="text-2xl font-bold mb-3">Wired, Professional Devices</h3>
                <p class="text-gray-600 mb-6">Our professional wired devices offer maximum reliability and security.
                    Ideal for heavy-duty vehicles, hidden installations, and advanced integrations like fuel sensors and
                    engine immobilization.</p>
                <ul class="space-y-3 text-gray-700">
                    <li class="flex items-center"><i data-lucide="check-circle" class="w-5 h-5 text-green-500 mr-2"></i>
                        Tamper-proof installation</li>
                    <li class="flex items-center"><i data-lucide="check-circle" class="w-5 h-5 text-green-500 mr-2"></i>
                        Extended battery backup</li>
                    <li class="flex items-center"><i data-lucide="check-circle" class="w-5 h-5 text-green-500 mr-2"></i>
                        IO ports for sensors & accessories</li>
                </ul>
            </div>
            <div class="bg-white p-8 rounded-2xl shadow-3xl border-t-4 border-primary">
                <i data-lucide="plug-zap" class="text-primary w-12 h-12 mb-4"></i>
                <h3 class="text-2xl font-bold mb-3">OBD Plug & Play Simplicity</h3>
                <p class="text-gray-600 mb-6">The fastest way to start tracking. Simply plug the device into your
                    vehicle's OBD port and you're live. Perfect for passenger vehicles and instant deployment.</p>
                <ul class="space-y-3 text-gray-700">
                    <li class="flex items-center"><i data-lucide="check-circle" class="w-5 h-5 text-green-500 mr-2"></i>
                        Self-installation in seconds</li>
                    <li class="flex items-center"><i data-lucide="check-circle" class="w-5 h-5 text-green-500 mr-2"></i>
                        Diagnostic data readouts (select models)</li>
                    <li class="flex items-center"><i data-lucide="check-circle" class="w-5 h-5 text-green-500 mr-2"></i>
                        Easy transfer between vehicles</li>
                </ul>
            </div>
        </div>
    </div>
</section>

<section id="plans" class="py-16 md:py-24 bg-gray-50">
    <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <h2 class="text-4xl font-bold text-center text-gray-900 mb-4">Flexible & Transparent Plans</h2>
        <p class="text-xl text-center text-gray-600 mb-12">Choose the right feature set for your business size and
            complexity.</p>
        <div class="grid grid-cols-1 lg:grid-cols-3 gap-8">
            <div
                class="bg-white p-8 rounded-2xl shadow-xl border border-gray-100 flex flex-col transform hover:scale-[1.02] transition duration-500">
                <h3 class="text-2xl font-bold text-gray-900 mb-2">Basic</h3>
                <p class="text-gray-500 mb-6">Essential tracking for small fleets.</p>
                <div class="text-4xl font-extrabold text-primary mb-6">INR 300<span
                        class="text-xl font-medium text-gray-600">/vehicle/mo</span></div>
                <ul class="space-y-4 flex-grow mb-8">
                    <li class="flex items-center text-gray-700"><i data-lucide="check"
                            class="w-5 h-5 text-green-500 mr-2"></i> Upto 10 Devices</li>
                    <li class="flex items-center text-gray-700"><i data-lucide="check"
                            class="w-5 h-5 text-green-500 mr-2"></i> Live Tracking (5-min updates)</li>
                    <li class="flex items-center text-gray-700"><i data-lucide="check"
                            class="w-5 h-5 text-green-500 mr-2"></i> Basic Reports (Daily/Weekly)</li>
                    <li class="flex items-center text-gray-700"><i data-lucide="check"
                            class="w-5 h-5 text-green-500 mr-2"></i> Mobile App Access</li>
                    <li class="flex items-center text-gray-400 line-through"><i data-lucide="x"
                            class="w-5 h-5 text-red-500 mr-2"></i> Geofence & Trip Management</li>
                    <li class="flex items-center text-gray-400 line-through"><i data-lucide="x"
                            class="w-5 h-5 text-red-500 mr-2"></i> WhatsApp Notifications</li>
                    <li class="flex items-center text-gray-400 line-through"><i data-lucide="x"
                            class="w-5 h-5 text-red-500 mr-2"></i> Dedicated API Access</li>
                </ul>
                <a href="tel:919724305392"
                    class="block text-center w-full text-primary border border-primary py-3 rounded-lg font-bold hover:bg-gray-100 transition duration-300">
                    Choose Basic
                </a>
            </div>

            <div
                class="bg-white p-8 rounded-2xl shadow-3xl ring-4 ring-primary ring-offset-4 flex flex-col transform scale-[1.05] transition duration-500 z-10">
                <span
                    class="bg-primary text-white text-xs font-bold uppercase tracking-wider px-3 py-1 rounded-full absolute -top-3 left-1/2 transform -translate-x-1/2">Most
                    Popular</span>
                <h3 class="text-2xl font-bold text-gray-900 mb-2">Pro</h3>
                <p class="text-gray-500 mb-6">Full suite of operational features and premium support.</p>
                <div class="text-4xl font-extrabold text-primary mb-6">INR 350<span
                        class="text-xl font-medium text-gray-600">/vehicle/mo</span></div>
                <ul class="space-y-4 flex-grow mb-8">
                    <li class="flex items-center text-gray-700"><i data-lucide="check"
                            class="w-5 h-5 text-green-500 mr-2"></i> 10 to 100 Devices</li>
                    <li class="flex items-center text-gray-700"><i data-lucide="check"
                            class="w-5 h-5 text-green-500 mr-2"></i> Live Tracking (Real-time)</li>
                    <li class="flex items-center text-gray-700"><i data-lucide="check"
                            class="w-5 h-5 text-green-500 mr-2"></i> Advanced Reports & Analytics</li>
                    <li class="flex items-center text-gray-700"><i data-lucide="check"
                            class="w-5 h-5 text-green-500 mr-2"></i> Geofence & Trip Management</li>
                    <li class="flex items-center text-gray-700"><i data-lucide="check"
                            class="w-5 h-5 text-green-500 mr-2"></i> WhatsApp Notifications</li>
                    <li class="flex items-center text-gray-700"><i data-lucide="check"
                            class="w-5 h-5 text-green-500 mr-2"></i> Vehicle Maintenance Reminders</li>
                    <li class="flex items-center text-gray-700"><i data-lucide="check"
                            class="w-5 h-5 text-green-500 mr-2"></i> Dedicated API Access (Limit)</li>
                </ul>
                <a href="tel:919724305392"
                    class="block text-center w-full bg-primary text-white py-3 rounded-lg font-bold hover:bg-primary-dark transition duration-300 shadow-xl">
                    Start Pro Trial
                </a>
            </div>

            <div
                class="bg-white p-8 rounded-2xl shadow-xl border border-gray-100 flex flex-col transform hover:scale-[1.02] transition duration-500">
                <h3 class="text-2xl font-bold text-gray-900 mb-2">Enterprise</h3>
                <p class="text-gray-500 mb-6">Custom features, priority support, and unlimited API usage.</p>
                <div class="text-4xl font-extrabold text-primary mb-6">Custom<span
                        class="text-xl font-medium text-gray-600">/quote</span></div>
                <ul class="space-y-4 flex-grow mb-8">
                    <li class="flex items-center text-gray-700"><i data-lucide="check"
                            class="w-5 h-5 text-green-500 mr-2"></i> More than 100 Devices</li>
                    <li class="flex items-center text-gray-700"><i data-lucide="check"
                            class="w-5 h-5 text-green-500 mr-2"></i> All Pro Features Included</li>
                    <li class="flex items-center text-gray-700"><i data-lucide="check"
                            class="w-5 h-5 text-green-500 mr-2"></i> Unlimited API Access</li>
                    <li class="flex items-center text-gray-700"><i data-lucide="check"
                            class="w-5 h-5 text-green-500 mr-2"></i> Custom Report Development</li>
                    <li class="flex items-center text-gray-700"><i data-lucide="check"
                            class="w-5 h-5 text-green-500 mr-2"></i> Priority 24/7 Technical Support</li>
                    <li class="flex items-center text-gray-700"><i data-lucide="check"
                            class="w-5 h-5 text-green-500 mr-2"></i> Dedicated Account Manager</li>
                    <li class="flex items-center text-gray-700"><i data-lucide="check"
                            class="w-5 h-5 text-green-500 mr-2"></i> SSO/LDAP Integration</li>
                </ul>
                <a href="tel:919724305392"
                    class="block text-center w-full bg-gray-800 text-white py-3 rounded-lg font-bold hover:bg-gray-700 transition duration-300">
                    Contact Sales
                </a>
            </div>
        </div>
    </div>
</section>

<section class="py-16 bg-primary">
    <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <h2 class="text-4xl font-bold text-white mb-4">Ready to Transform Your Fleet Management?</h2>
        <p class="text-xl mb-8 text-white opacity-90">Join thousands of businesses relying on AnTim GPS for accurate,
            reliable VTS.</p>
        <a href="tel:919724305392"
            class="inline-block text-center bg-white text-primary px-8 py-4 text-lg rounded-xl font-bold hover:bg-gray-100 transition duration-300 shadow-xl">
            Call Now
        </a>
    </div>
</section>

<footer class="bg-gray-800 text-white py-12">
    <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 grid grid-cols-2 md:grid-cols-4 gap-8">
        <div>
            <h4 class="text-xl font-bold mb-4">AnTim GPS</h4>
            <p class="text-gray-400 text-sm">Best-in-class VTS platform with wired and plug-and-play OBD devices.</p>
        </div>
        <div>
            <h4 class="text-lg font-semibold mb-4">Quick Links</h4>
            <ul class="space-y-2 text-sm">
                <li><a (click)="scrollToSection($event, 'features')"
                        class="cursor-pointer text-gray-400 hover:text-white transition duration-200">Features</a></li>
                <li><a (click)="scrollToSection($event, 'devices')"
                        class="cursor-pointer text-gray-400 hover:text-white transition duration-200">Devices</a></li>
                <li><a (click)="scrollToSection($event, 'plans')"
                        class="cursor-pointer text-gray-400 hover:text-white transition duration-200">Pricing</a></li>
                <li><a href="#" class="text-gray-400 hover:text-white transition duration-200"
                        (click)="showModal('contact'); $event.preventDefault()">Contact Us</a></li>
            </ul>
        </div>
        <div>
            <h4 class="text-lg font-semibold mb-4">Features</h4>
            <ul class="space-y-2 text-sm">
                <li><a (click)="scrollToSection($event, 'features')"
                        class="cursor-pointer text-gray-400 hover:text-white transition duration-200">Live Tracking</a>
                </li>
                <li><a (click)="scrollToSection($event, 'features')"
                        class="cursor-pointer text-gray-400 hover:text-white transition duration-200">APIs & ERP
                        Integration</a></li>
                <li><a (click)="scrollToSection($event, 'features')"
                        class="cursor-pointer text-gray-400 hover:text-white transition duration-200">Mobile Apps</a>
                </li>
                <li><a (click)="scrollToSection($event, 'features')"
                        class="cursor-pointer text-gray-400 hover:text-white transition duration-200">WhatsApp
                        Alerts</a></li>
            </ul>
        </div>
        <div>
            <h4 class="text-lg font-semibold mb-4">Contact</h4>
            <p class="text-gray-400 text-sm mb-2">4th Floor, Maan Square, Nr. Soham Circle, Althan Canal Road,
                Surat-395017</p>
            <p class="text-gray-400 text-sm mb-2">timir&#64;antimtechnologies.com</p>
            <p class="text-gray-400 text-sm"><a href="tel:919724305392">(91) 9724305392</a></p>
        </div>
    </div>
    <div class="mt-8 pt-6 border-t border-gray-700 text-center text-gray-500 text-sm">
        &copy; 2026 AnTim GPS. All rights reserved.
    </div>
</footer>

<div id="auth-modal"
    class="fixed inset-0 bg-gray-900 bg-opacity-75 z-50 transition-opacity duration-300 items-center justify-center"
    [class.hidden]="activeModal === null" [class.flex]="activeModal !== null" (click)="hideModal()">

    <div id="modal-content" (click)="$event.stopPropagation()"
        class="bg-white p-8 rounded-2xl shadow-3xl w-11/12 max-w-lg transform transition-transform duration-300 scale-95">
        <div class="flex justify-between items-center mb-6">
            <h3 id="modal-title" class="text-2xl font-bold text-gray-900">{{ modalTitle }}</h3>
            <button id="close-modal-btn" class="text-gray-500 hover:text-gray-800" (click)="hideModal()">
                <i data-lucide="x" class="w-6 h-6"></i>
            </button>
        </div>
        <div id="form-container">

            <form id="signup-form" class="space-y-4" [class.hidden]="activeModal !== 'signup'"
                (submit)="onSubmitSignup($event, signupEmail.value)">
                <div>
                    <label for="signup-name" class="block text-sm font-medium text-gray-700">Full Name</label>
                    <input type="text" id="signup-name"
                        class="mt-1 block w-full px-4 py-2 border border-gray-300 rounded-lg shadow-sm">
                </div>
                <div>
                    <label for="signup-email" class="block text-sm font-medium text-gray-700">Email Address</label>
                    <input type="email" id="signup-email" #signupEmail
                        class="mt-1 block w-full px-4 py-2 border border-gray-300 rounded-lg shadow-sm">
                </div>
                <div>
                    <label for="signup-password" class="block text-sm font-medium text-gray-700">Password</label>
                    <input type="password" id="signup-password"
                        class="mt-1 block w-full px-4 py-2 border border-gray-300 rounded-lg shadow-sm">
                </div>
                <button type="submit"
                    class="w-full bg-primary text-white py-3 rounded-lg font-bold hover:bg-primary-dark transition duration-300 shadow-md">Create
                    Account</button>
                <p class="text-center text-sm text-gray-600">Already have an account?
                    <a href="#" (click)="showModal('login'); $event.preventDefault()"
                        class="text-primary font-medium">Log In</a>
                </p>
            </form>

            <form id="login-form" class="space-y-4" [class.hidden]="activeModal !== 'login'"
                (submit)="onSubmitLogin($event, loginEmail.value)">
                <div>
                    <label for="login-email" class="block text-sm font-medium text-gray-700">Email Address</label>
                    <input type="email" id="login-email" #loginEmail
                        class="mt-1 block w-full px-4 py-2 border border-gray-300 rounded-lg shadow-sm">
                </div>
                <div>
                    <label for="login-password" class="block text-sm font-medium text-gray-700">Password</label>
                    <input type="password" id="login-password"
                        class="mt-1 block w-full px-4 py-2 border border-gray-300 rounded-lg shadow-sm">
                </div>
                <button type="submit"
                    class="w-full bg-primary text-white py-3 rounded-lg font-bold hover:bg-primary-dark transition duration-300 shadow-md">Log
                    In</button>
                <p class="text-center text-sm text-gray-600">Don't have an account?
                    <a href="#" (click)="showModal('signup'); $event.preventDefault()"
                        class="text-primary font-medium">Sign Up</a>
                </p>
            </form>

            <div id="contact-message" class="text-center p-6" [class.hidden]="activeModal !== 'contact'">
                <i data-lucide="mail-check" class="w-12 h-12 text-primary mx-auto mb-4"></i>
                <p class="text-lg font-semibold mb-2">Request a Custom Quote</p>
                <p class="text-gray-600">Please contact our sales team at <strong
                        class="text-primary">timir&#64;antimtechnologies.com</strong><br/> or<br/>
                        call <a
                        href="tel:919724305392">(91) 9724305392</a></p>
            </div>
        </div>

        <div id="message-box"
            class="fixed bottom-5 right-5 bg-green-500 text-white p-4 rounded-lg shadow-xl transition-all duration-300 z-50"
            [class.hidden]="!isMessageVisible" [class.opacity-100]="isMessageVisible"
            [class.translate-y-0]="isMessageVisible" [class.opacity-0]="!isMessageVisible"
            [class.translate-y-full]="!isMessageVisible">
            <p id="message-text">{{ messageText }}</p>
        </div>
    </div>
</div>